import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UrlHelper {
  /**
   * Returns the current path name without the base href
   */
  public getPathNameWithoutBaseHref(pathName: string = window.location.pathname): string {
    // We have to remove the base href path in preproduction
    const regex = /^\/exchange\/?(.*)$/gm;
    const subst = `$1`;

    return pathName.replace(regex, subst);
  }
}
